import { useRef, useState } from 'react';
import { useFedContent, uploadUrl } from '../content';
import { useAppStore } from '../../store';
import { Ic } from '../icons';
import { AdmCard } from './ui';

export default function AdmGallery() {
  const photos = useFedContent((s) => s.gallery) || [];
  const uploadGalleryImage = useFedContent((s) => s.uploadGalleryImage);
  const addGalleryItems = useFedContent((s) => s.addGalleryItems);
  const deleteGalleryItem = useFedContent((s) => s.deleteGalleryItem);
  const fire = useAppStore((s) => s.fire);
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [progress, setProgress] = useState('');

  const pick = async (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = '';
    if (!files.length || busy) return;
    setBusy(true);
    const added = [];
    try {
      for (let i = 0; i < files.length; i += 1) {
        setProgress(`${i + 1} / ${files.length}`);
        const file = files[i];
        const path = await uploadGalleryImage(file);
        added.push({ path, originalName: file.name, title_ru: '', title_kz: '', date: new Date().toLocaleDateString('ru-RU') });
      }
      const ok = await addGalleryItems(added);
      if (!ok) throw new Error('Не удалось опубликовать галерею');
      fire(`Загружено фотографий: ${added.length}`, 'ok');
    } catch (error) {
      fire(error.message || 'Не удалось загрузить фотографии', 'error');
    } finally {
      setBusy(false);
      setProgress('');
    }
  };

  const remove = async (photo) => {
    if (!window.confirm(`Удалить «${photo.title_ru || photo.originalName || 'фотографию'}» из галереи?`)) return;
    const ok = await deleteGalleryItem(photo.id);
    if (ok) fire('Фотография убрана из галереи', 'ok');
  };

  return (
    <div className="fed-admin-view flex flex-col gap-4">
      <AdmCard className="adm-gallery-upload">
        <div>
          <span>Фотоархив федерации</span>
          <h2>Загрузка оригиналов</h2>
          <p>Можно выбрать сразу несколько фотографий до 25 МБ каждая. Файлы сохраняются без сжатия и изменения разрешения.</p>
        </div>
        <button disabled={busy} onClick={() => input.current?.click()} className="fed-btn-primary adm-gallery-upload-btn">
          <Ic name={busy ? 'image' : 'plus'} size={18} />{busy ? `Загружаем ${progress}` : 'Добавить фотографии'}
        </button>
        <input ref={input} hidden multiple type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/bmp" onChange={pick} />
      </AdmCard>

      {photos.length ? <div className="adm-gallery-grid">
        {photos.map((photo) => <article className="adm-gallery-item" key={photo.id || photo.path}>
          <img src={uploadUrl(photo.path)} alt={photo.title_ru || ''} loading="lazy" />
          <div><span title={photo.originalName}>{photo.originalName || 'Фотография'}</span><button onClick={() => remove(photo)} aria-label="Удалить фотографию"><Ic name="trash" size={17} /></button></div>
        </article>)}
      </div> : <div className="fed-gallery-empty"><Ic name="image" size={34} /><b>В галерее пока нет фотографий</b><span>Загрузите первые кадры с мероприятия</span></div>}
    </div>
  );
}
